import { render, staticRenderFns } from "./ForumBreadcrumbs.vue?vue&type=template&id=44674164&scoped=true&"
import script from "./ForumBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ForumBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ForumBreadcrumbs.vue?vue&type=style&index=0&id=44674164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44674164",
  null
  
)

export default component.exports